import React from 'react';
import { Shield, Users, Database, Key, Activity } from 'lucide-react';

function AdminSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Admin</h2>
        <p className="text-slate-400 mt-1">System administration and governance</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-purple-600/20 flex items-center justify-center">
              <Users className="w-5 h-5 text-purple-400" />
            </div>
            <h3 className="text-lg font-semibold text-white">Users</h3>
          </div>
          <p className="text-2xl font-bold text-white">3</p>
          <p className="text-xs text-slate-500 mt-1">2 active · 1 suspended</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-emerald-600/20 flex items-center justify-center">
              <Key className="w-5 h-5 text-emerald-400" />
            </div>
            <h3 className="text-lg font-semibold text-white">API Keys</h3>
          </div>
          <p className="text-2xl font-bold text-white">8</p>
          <p className="text-xs text-slate-500 mt-1">5 active · 3 expired</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-amber-600/20 flex items-center justify-center">
              <Database className="w-5 h-5 text-amber-400" />
            </div>
            <h3 className="text-lg font-semibold text-white">Databases</h3>
          </div>
          <p className="text-2xl font-bold text-white">4</p>
          <p className="text-xs text-slate-500 mt-1">MongoDB · SQLite · Redis · Milvus</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-red-600/20 flex items-center justify-center">
              <Shield className="w-5 h-5 text-red-400" />
            </div>
            <h3 className="text-lg font-semibold text-white">Audit Log</h3>
          </div>
          <p className="text-2xl font-bold text-white">1,247</p>
          <p className="text-xs text-slate-500 mt-1">Events recorded this month</p>
        </div>
      </div>
    </div>
  );
}

export default AdminSection;
